import React from 'react';
import './industry.scss';
import Parser from 'html-react-parser';
import { umoksType } from '../../types/types.js';
import { Link } from 'react-router-dom';

class Industry extends React.Component {
  constructor(props) {
    super(props);
  };
  componentWillMount() {

    // function* quips(name) {
    //     yield "привет, " + name + "!";
    //     yield "я надеюсь, вам нравятся статьи";
    //     if (name.startsWith("X")) {
    //         yield "как круто, что ваше имя начинается с X, " + name;
    //     }
    //     yield "увидимся!";
    //     yield "завтра!";
    // };
    //
    // let  fff =  quips('vasa');
    //
    // console.log( fff.next() );
    // console.log( fff.next() );
    // console.log( fff.next() );


  };

	getContent = () => {
	   const { industryList } = this.props;

	       return industryList && industryList.map((item, i, arr) => {
	       return (
	      <div key={'card-wrap-' + i} className='f-item f-item-4'>

    <div className='card-wrap'>
	          <Link to={item.link}>
        <i  id={'i-card-wrap-' + i} className={item.img + ' undecorate-img'} />
      </Link>
  {Parser(item.content)}
	        </div>
  </div>
	    );
	  });
	};
	render() {
	  return (
  <sectuion className='company-wrap f-center'>
  <div className='f-container'>
  <div className='f-row'>
  {this.getContent()}
	        </div>
	      </div>
	    </sectuion>
	  );
	};
};


Industry.propTypes = {
  industryList:umoksType.isRequired
};

export default Industry;



// WEBPACK FOOTER //
// ./src/client/components/industry/industry.jsx